import { saveDefaultsToSource, type SaveDefaultsResult } from '../dev/saveDefaults';
import defaults from './Audio.defaults.json';
import { DEFAULT_SFX, type SfxConfig } from './Sfx';
import { clonePreset, DEFAULT_PRESET, type AudioPreset } from './audio-presets';

export interface AudioMixDefaults {
  master: number;
  engine: number;
  sfx: number;
  music: number;
}

export interface AudioDefaults {
  mix: AudioMixDefaults;
  sfx: SfxConfig;
  enginePreset: AudioPreset;
}

export const AUDIO_DEFAULTS_FILE = 'src/audio/Audio.defaults.json' as const;
export const DEFAULT_AUDIO_MIX: AudioMixDefaults = {
  master: 0.75,
  engine: 0.25,
  sfx: 0.35,
  music: 1,
};

export function loadAudioDefaults(): AudioDefaults {
  const source = defaults as Partial<AudioDefaults>;
  return {
    mix: { ...DEFAULT_AUDIO_MIX, ...(source.mix ?? {}) },
    sfx: mergeSfxConfig(source.sfx),
    enginePreset: clonePreset(source.enginePreset ?? DEFAULT_PRESET),
  };
}

export function saveAudioDefaultsToSource(
  payload: AudioDefaults,
): Promise<SaveDefaultsResult> {
  return saveDefaultsToSource(AUDIO_DEFAULTS_FILE, payload);
}

function mergeSfxConfig(source: Partial<SfxConfig> | undefined): SfxConfig {
  return {
    ...DEFAULT_SFX,
    ...(source ?? {}),
    backfire: { ...DEFAULT_SFX.backfire, ...(source?.backfire ?? {}) },
    boost: { ...DEFAULT_SFX.boost, ...(source?.boost ?? {}) },
    slipRasp: { ...DEFAULT_SFX.slipRasp, ...(source?.slipRasp ?? {}) },
    kerb: { ...DEFAULT_SFX.kerb, ...(source?.kerb ?? {}) },
    thunk: { ...DEFAULT_SFX.thunk, ...(source?.thunk ?? {}) },
    scrape: { ...DEFAULT_SFX.scrape, ...(source?.scrape ?? {}) },
    airBrake: { ...DEFAULT_SFX.airBrake, ...(source?.airBrake ?? {}) },
    ignite: { ...DEFAULT_SFX.ignite, ...(source?.ignite ?? {}) },
  };
}
